export default {
    activity_log: 'Activity Log',
    action_name: 'Action Name',
    reference_for: 'Reference For',
    ip: 'IP',
    actions: {
        change_email: {
            title: 'Change Email',
            content: 'You have just successfully changed your email.',
        },
        change_root_password_cloud_server: {
            title: 'Change Cloud Server Root Password',
            content: 'You have just changed the root password of Cloud Server.',
        },
        use_trial_sms: {
            title: 'Use Trial SMS',
            content: 'You have used trial SMS.',
        },
        login: {
            title: 'Login',
            content: 'You have just logged in successfully',
            error: {
                wrong_password: 'Login failed due to incorrect password',
            },
        },
        register: {
            title: 'Register',
            content: 'You have just successfully registered',
        },
        verify_two_factor: {
            title: 'Two-Factor Authenticator',
            content:
                'You have just successfully verified your Two-Factor Authenticator',
            error: {
                invalid_2fa_code:
                    'Two-factor verification failed due to incorrect code',
            },
        },
        change_shared_hosting_password: {
            title: 'Change Shared Hosting Password',
            content: 'You have just changed the password of Shared Hosting.',
        },
        change_wordpress_hosting_password: {
            title: 'Change WordPress Hosting Password',
            content: 'You have just changed the password of WordPress Hosting.',
        },
        change_cloud_hosting_terminal_password: {
            title: 'Change Cloud Hosting Terminal Password',
            content:
                'You have just changed the terminal password of Cloud Hosting.',
        },
        change_cloud_hosting_panel_password: {
            title: 'Change Cloud Hosting Panel Password',
            content:
                'You have just changed the panel password of Cloud Hosting.',
        },
        google_login: {
            title: 'Google Login',
            content: 'You have successfully logged in via Google Account',
        },
        google_linked: {
            title: 'Google Linked',
            content: 'You have successfully linked your Google Account',
        },
        google_unlink: {
            title: 'Google Unlink',
            content: 'You have successfully unlinked your Google Account',
        },
    },
    detail: {
        title: 'Activity Detail',
        field_name: 'Field Name',
        previous_value: 'Previous Value',
        new_value: 'New Value',
    },
    search_placeholder: 'Enter IP',
    select_action_placeholder: 'Search & select action',
    recommend: 'Recommend:',
};
